import { StripeProduct, StripeProducts } from 'types'

export const sortStripeProducts = (products: StripeProducts): StripeProducts =>
  products.sort(compareStripeProductPrice)

function compareStripeProductPrice(a: StripeProduct, b: StripeProduct): number {
  return a.amount > b.amount ? 1 : -1
}
